var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { isEmpty } from 'lodash';
import ELSIcon from '../els-icon/ELSIcon';
var baseButtonClass = 'c-els-button';
export var BUTTON_VARIANTS = {
    secondary: "".concat(baseButtonClass, "--secondary"),
    tertiary: "".concat(baseButtonClass, "--tertiary"),
    info: "".concat(baseButtonClass, "--info"),
    warn: "".concat(baseButtonClass, "--warn"),
    confirm: "".concat(baseButtonClass, "--confirm"),
    outlined: "".concat(baseButtonClass, "--outlined")
};
export var BUTTON_SIZES = {
    xsmall: "".concat(baseButtonClass, "--x-small"),
    small: "".concat(baseButtonClass, "--small"),
    medium: "".concat(baseButtonClass, "--medium"),
    large: "".concat(baseButtonClass, "--large")
};
export var getButtonClassnames = function (_a) {
    var variant = _a.variant, size = _a.size, className = _a.className, iconLeft = _a.iconLeft, iconRight = _a.iconRight;
    var displayVariant = variant && Object.keys(BUTTON_VARIANTS).includes(variant) ? BUTTON_VARIANTS[variant] : '';
    var displaySize = size && Object.keys(BUTTON_SIZES).includes(size) ? BUTTON_SIZES[size] : '';
    var iconLeftClass = iconLeft || iconRight ? "".concat(baseButtonClass, "--icon") : '';
    var iconRightClass = iconRight ? "".concat(baseButtonClass, "--icon-right") : '';
    return cx("".concat(baseButtonClass), displayVariant, displaySize, iconLeftClass, iconRightClass, className);
};
var ELSButton = forwardRef(function (_a, ref) {
    var variant = _a.variant, size = _a.size, iconLeft = _a.iconLeft, iconRight = _a.iconRight, className = _a.className, children = _a.children, props = __rest(_a, ["variant", "size", "iconLeft", "iconRight", "className", "children"]);
    return (<button ref={ref} type="button" {...props} className={getButtonClassnames({ variant: variant, size: size, className: className, iconLeft: iconLeft, iconRight: iconRight })}>
    {!isEmpty(iconLeft) && <ELSIcon {...iconLeft}/>}
    {children}
    {!isEmpty(iconRight) && <ELSIcon {...iconRight}/>}
  </button>);
});
ELSButton.displayName = 'ELSButton';
export default ELSButton;
